// extracted by mini-css-extract-plugin
export default {"AttendanceStats":"AttendanceStats_AttendanceStats__cH7gW"};